module.exports = __webpack_public_path__ + "static/media/many-more.38ef1120.png";